import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { BasicTable } from "../scripts/Tables";
import Loader from "react-loader-spinner";

function AutoProcessedDialog({ open, onClose, caseactivityData, isLoading }) {
  
  var colums = [
    {
      width: "20%",
      Header: "Timestamp",
      accessor: "CreateDate_DT",
    },
    {
      Header: "Activity",
      accessor: "Activity_CR",
    },
  ];

  // const

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        className="largeModalWrapper"
      >
        <DialogTitle variant="h6" onClose={onClose} className="dialog-title">
          Audit Logs
          {onClose ? <CloseIcon onClick={onClose} /> : null}
        </DialogTitle>
        <DialogContent>
          <hr className="hr-style" />
          <Box className="tasklist-table audit-log-table">
            {isLoading ? (
              <Box className="loaderParent">
                <Loader type="Puff" color="#00BFFF" height={100} width={100} />
              </Box>
            ) : (
              <BasicTable
                columns={colums}
                tableData={caseactivityData}
                tableType="default"
              />
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default AutoProcessedDialog;
